(function () {
  if (window.__swxPages) return;
  window.__swxPages = true;
  var fine = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal() {
    var els = document.querySelectorAll('[data-swx-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -12% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function tilt() {
    if (!fine || reduce) return;
    document.querySelectorAll('[data-swx-tilt]:not([data-tilt-on])').forEach(function (el) {
      el.setAttribute('data-tilt-on', '1');
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        el.style.transform = 'perspective(900px) rotateX(' + (-y * 6).toFixed(2) + 'deg) rotateY(' + (x * 8).toFixed(2) + 'deg) translateY(-4px)';
        el.style.setProperty('--mx', ((x + 0.5) * 100).toFixed(1) + '%');
        el.style.setProperty('--my', ((y + 0.5) * 100).toFixed(1) + '%');
      });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });
  }

  function toc() {
    document.querySelectorAll('[data-swx-policy]:not([data-toc-on])').forEach(function (root) {
      root.setAttribute('data-toc-on', '1');
      var body = root.querySelector('[data-swx-policy-body]');
      var list = root.querySelector('[data-swx-toc]');
      var bar = root.querySelector('[data-swx-progress]');
      if (!body) return;
      var hs = Array.prototype.slice.call(body.querySelectorAll('h2, h3'));
      var level = body.querySelector('h2') ? 'H2' : 'H3';
      var tEl = root.querySelector('[data-swx-title]');
      var norm = function (t) { return t.toLowerCase().replace(/[^a-z0-9]+/g, ''); };
      var title = tEl ? norm(tEl.textContent) : '';
      hs.forEach(function (h) { if (title && norm(h.textContent) === title) h.classList.add('is-dup'); });
      hs = hs.filter(function (h) { return h.tagName === level && h.textContent.trim() && !h.classList.contains('is-dup'); });
      if (list) {
        if (hs.length < 2) { root.classList.add('no-toc'); }
        hs.forEach(function (h, i) {
          var id = 'sec-' + (i + 1);
          h.id = h.id || id;
          var a = document.createElement('a');
          a.href = '#' + h.id;
          a.textContent = h.textContent.trim().replace(/^\d+[.)]\s*/, '').replace(/[:：]\s*$/, '');
          var n = document.createElement('i'); n.textContent = (i + 1 < 10 ? '0' : '') + (i + 1);
          a.prepend(n);
          a.addEventListener('click', function (e) {
            e.preventDefault();
            var hh = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sxh-h')) || 70;
            window.scrollTo({ top: h.getBoundingClientRect().top + window.scrollY - hh - 20, behavior: 'smooth' });
          });
          list.appendChild(a);
        });
      }
      var links = list ? Array.prototype.slice.call(list.querySelectorAll('a')) : [];
      function onScroll() {
        var r = body.getBoundingClientRect(), vh = window.innerHeight;
        var p = Math.min(1, Math.max(0, (vh * 0.3 - r.top) / (r.height - vh * 0.4)));
        if (bar) bar.style.transform = 'scaleX(' + p.toFixed(3) + ')';
        var cur = 0;
        hs.forEach(function (h, i) { if (h.getBoundingClientRect().top < vh * 0.35) cur = i; });
        links.forEach(function (a, i) {
          var on = i === cur;
          if (on && !a.classList.contains('is-on') && list.scrollWidth > list.clientWidth) {
            list.scrollTo({ left: a.offsetLeft - 8, behavior: 'smooth' });
          }
          a.classList.toggle('is-on', on);
        });
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    });
  }

  function copy() {
    document.querySelectorAll('[data-swx-copy]:not([data-copy-on])').forEach(function (b) {
      b.setAttribute('data-copy-on', '1');
      b.addEventListener('click', function () {
        var done = function () {
          var l = b.querySelector('span'); if (!l) return;
          var t = l.textContent; l.textContent = 'Copied!'; b.classList.add('is-ok');
          setTimeout(function () { l.textContent = t; b.classList.remove('is-ok'); }, 1800);
        };
        if (navigator.clipboard) navigator.clipboard.writeText(b.getAttribute('data-swx-copy')).then(done, done); else done();
      });
    });
  }

  function init() { reveal(); tilt(); toc(); copy(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
